import { ErrorMessage } from "~/shared/ui/components/errors/ErrorMessage"

import { useError } from "./ErrorBoundary"

export function ErrorMessageFallback() {
	const error = useError()
	return <ErrorMessage error={error} />
}
